import { apiUrl } from "Constants";

// Statuts d'un véhicule de l'inventaire (/mplus/stock) → libellé et style de badge.
export const VEHICLE_STATUS = {
  RECEIVED: { label: "Reçu", badge: "statusIndisponible" },
  AVAILABLE: { label: "Disponible", badge: "statusDisponible" },
  RESERVED: { label: "Réservé", badge: "statusRéservé" },
  CONTRACTED: { label: "Sous contrat", badge: "statusRéservé" },
  ACTIVE: { label: "En circulation", badge: "statusLivré" },
  OWNED: { label: "Propriété client", badge: "statusLivré" },
  IN_TRANSIT: { label: "En transit", badge: "statusLivré" },
  QUARANTINED: { label: "Quarantaine", badge: "statusBloqué" },
  RETURNED: { label: "Restitué", badge: "statusIndisponible" },
  WRITTEN_OFF: { label: "Sorti", badge: "statusIndisponible" },
};

// Actions POST /mplus/stock/:id/<key>.
// location : champ d'emplacement à envoyer ; reason : "required" | "optional".
export const VEHICLE_ACTIONS = {
  "make-available": {
    label: "Mettre en vente",
    description: "Le véhicule devient disponible à la vente. Les 4 contrôles avant vente sont exigés.",
    success: "Véhicule mis en vente.",
  },
  transfer: {
    label: "Transférer",
    description: "Le véhicule passe « En transit » et n'est plus vendable jusqu'à sa réception. Un véhicule réservé garde sa réservation.",
    location: "to_location_id",
    locationLabel: "Emplacement de destination",
    success: "Transfert lancé.",
  },
  "receive-transfer": {
    label: "Réceptionner à l'arrivée",
    description: "Le véhicule reprend le statut qu'il avait avant le transfert.",
    success: "Véhicule réceptionné.",
  },
  quarantine: {
    label: "Mettre en quarantaine",
    description: "Véhicule abîmé ou à contrôler : il n'est plus vendable.",
    reason: "required",
    success: "Véhicule mis en quarantaine.",
  },
  "back-to-received": {
    label: "Remettre en stock",
    description: "Après quarantaine ou restitution. Le véhicule repasse par les contrôles avant vente.",
    reason: "required",
    success: "Véhicule remis en stock.",
  },
  return: {
    label: "Restitution par le client",
    description: "Véhicule repris au client (rupture, récupération).",
    location: "location_id",
    locationLabel: "Emplacement de retour",
    reason: "required",
    success: "Restitution enregistrée.",
  },
  "write-off": {
    label: "Sortir de l'inventaire",
    description: "Perte définitive (épave, vol). Action réservée à la finance.",
    reason: "required",
    danger: true,
    success: "Véhicule sorti de l'inventaire.",
  },
};

// Actions proposées selon le statut ; le serveur reste juge (MPLUS_STOCK_TRANSITION).
export const ACTIONS_BY_STATUS = {
  RECEIVED: ["make-available", "transfer", "quarantine", "write-off"],
  AVAILABLE: ["transfer", "quarantine", "write-off"],
  RESERVED: ["transfer"],
  CONTRACTED: ["transfer"],
  ACTIVE: ["return"],
  OWNED: [],
  IN_TRANSIT: ["receive-transfer"],
  QUARANTINED: ["back-to-received", "write-off"],
  RETURNED: ["back-to-received", "quarantine", "write-off"],
  WRITTEN_OFF: [],
};

const MPLUS_ERRORS = {
  MPLUS_VEHICLE_EXISTS: "Un véhicule avec ce châssis ou cette immatriculation existe déjà.",
  MPLUS_VEHICLE_NOT_READY: "Des contrôles avant vente manquent : complétez-les ou forcez la mise en vente (admin).",
  MPLUS_BYPASS_ADMIN_ONLY: "Seul un admin peut forcer la mise en vente.",
  MPLUS_STOCK_TRANSITION: "Cette action n'est pas possible dans le statut actuel du véhicule.",
  VALIDATION_ERROR: "Un champ est manquant ou invalide.",
  FORBIDDEN: "Votre rôle ne permet pas cette action.",
};

export const getErrorMessage = (error, fallback) => {
  const data = error?.response?.data || {};
  return MPLUS_ERRORS[data.code] || data.error || data.message || fallback;
};

export const formatMoney = (value, currency = "XAF") =>
  `${new Intl.NumberFormat("fr-FR").format(Math.round(Number(value) || 0))} ${currency}`;

export const formatDateTime = (value) =>
  value ? new Date(value).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "-";

export const toImageUrl = (path) => (!path ? null : /^https?:\/\//.test(path) ? path : `${apiUrl}${path}`);

// Les emplacements peuvent arriver en objet ({ name, code }) ou en texte.
export const locationName = (location) =>
  (typeof location === "string" ? location : location?.name || location?.code) || "-";

// Un contrôle manquant peut arriver en texte ou en objet ({ code, label }).
export const missingLabel = (item) => (typeof item === "string" ? item : item?.label || item?.code || "-");

export const statusLabel = (status) => VEHICLE_STATUS[status]?.label || status || "-";
